import React, { useEffect, useState } from 'react';
import '../../styles/atoms/page-loader.css';

interface PageLoaderProps {
  isLoading: boolean;
}

const PageLoader: React.FC<PageLoaderProps> = ({ isLoading }) => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setShowLoader(true);
    } else {
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  return (
    <div className={`page-loader ${showLoader ? 'page-loader--active' : ''}`}>
      <div className="page-loader__bar" />
    </div>
  );
};

export default PageLoader;
